import { useRef, useState } from 'react'

const useEditViewName = onSaveChanges => {
  const viewNameRef = useRef(null)
  const [isEditingViewName, setIsEditingViewName] = useState(false)

  const onAcceptEditViewName = () => {
    onSaveChanges(viewNameRef.current?.textContent)
    setIsEditingViewName(false)
  }

  const handleKeyDown = e => {
    if (viewNameRef.current.textContent.length >= 80 && e.key !== 'Backspace') {
      e.preventDefault()
    }

    if (e.key === 'Enter') {
      e.preventDefault()
      viewNameRef.current.contentEditable = false
      viewNameRef.current.removeEventListener('keydown', handleKeyDown)
      onAcceptEditViewName()
    }

    if (e.key === 'Escape') {
      e.preventDefault()
      viewNameRef.current.contentEditable = false
      viewNameRef.current.removeEventListener('keydown', handleKeyDown)
      setIsEditingViewName(false)
    }
  }

  const handleEditViewName = () => {
    setIsEditingViewName(true)
    setTimeout(() => {
      viewNameRef.current.contentEditable = true
      viewNameRef.current.addEventListener('keydown', handleKeyDown)
      viewNameRef.current.focus()
      const range = document.createRange()
      range.selectNodeContents(viewNameRef.current)
      range.collapse(false)
      const sel = window.getSelection()
      sel.removeAllRanges()
      sel.addRange(range)
    })
  }

  return { viewNameRef, isEditingViewName, setIsEditingViewName, handleEditViewName, onAcceptEditViewName }
}

export default useEditViewName
